import { Modal } from "@/ui/modals";
import { useState } from "react";
import { api } from "@/api/base-api-request";
import { IconComponent } from "@/ui/icon";
import { Button } from "@/ui/button.tsx";
import Select from "@/ui/select.tsx";
import UploadInput from "@ui/upload-input.tsx";

const ethOption = (
  <div className="flex flex-row gap-1 text-xs">
    <IconComponent name="ethereum" className="h-[1rem] w-[1rem]" />
    Ethereum
  </div>
);

const solOption = (
  <div className="flex flex-row gap-1 text-xs">
    <IconComponent name="solana" className="h-[0.8125rem] w-[0.8125rem]" />
    Solana
  </div>
);

const chainOptions = [
  { value: "eth", label: "Ethereum", component: ethOption },
  { value: "sol", label: "Solana", component: solOption },
];

const AddWalletsModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const [chain, setChain] = useState("eth");
  const [file, setFile] = useState<File | null>(null);

  const handleConfirm = () => {
    if (!file) return;

    const data = new FormData();
    data.append("file", file as Blob);

    api
      .post(`admin/uploadWallets/${chain}`, {
        body: data,
      })
      .then(() => {
        onClose();
      });
  };

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      className="w-[20rem] h-[8,9375rem] py-[0.9375rem] px-[0.6250rem] bg-section-gradient"
      size="20rem"
    >
      <Modal.Title title="Add Wallets" className="text-xs" />

      <div className="grid grid-cols-[4.3125rem,13.5rem] gap-x-[0.625rem] gap-y-[0.25rem] text-white text-xs items-center">
        <label className="min-h-[1.375rem]">Blockchain:</label>
        <Select
          data={chainOptions}
          initValue={{
            label: "Ethereum",
            value: "eth",
            component: ethOption,
          }}
          className="min-h-[1.375rem]"
          onChange={(e) => {
            if (e?.value) {
              setChain(e.value);
            }
          }}
        />

        <label className="text-right">Upload File:</label>
        <span className="h-[1.375rem]">
          <UploadInput setFile={setFile} />
        </span>
      </div>

      <Modal.Footer>
        <Button
          title="Confirm"
          className="w-[9.4375rem] font-semibold text-xs"
          onClick={handleConfirm}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default AddWalletsModal;
